import { render } from "./AddAndCloseTab.vue?vue&type=template&id=6540dea4"
import script from "./AddAndCloseTab.vue?vue&type=script&lang=js"
export * from "./AddAndCloseTab.vue?vue&type=script&lang=js"
script.render = render

export default script